import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { User } from '@/services/user.service'

export const useFundedLoanAccessStore = defineStore('fundedLoanAccess', () => {
  const hasFundedLoanAccess = ref(false)

  const getHasFundedLoanAccess = () => {
    return hasFundedLoanAccess.value
  }

  const setHasFundedLoanAccess = (hasFundedLoanAccessData: User) => {
    hasFundedLoanAccess.value = hasFundedLoanAccessData.hasFundedLoanAccess || false
  }

  return {
    getHasFundedLoanAccess,
    setHasFundedLoanAccess,
  }
})